import { BillingData } from 'gw-edge-client';
import { useState } from 'react';
const useActivateMPS = (): {
    activateMps: (policyNumber: string, payerPhoneNumber: string, redirectUrl: string) => void;
    showErrorMessage: boolean;
} => {
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const activateMps = (
        policyNumber: string,
        payerPhoneNumber: string,
        redirectUrl: string
    ): void => {
        BillingData.activateMps(policyNumber, payerPhoneNumber, redirectUrl)
            .then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            })
            .catch((e) => {
                setShowErrorMessage(true);
            });
    };

    return { activateMps, showErrorMessage };
};

export default useActivateMPS;
